import { render, staticRenderFns } from "./IQConfigurationTab.vue?vue&type=template&id=55770bdf&scoped=true"
import script from "./IQConfigurationTab.vue?vue&type=script&setup=true&lang=js"
export * from "./IQConfigurationTab.vue?vue&type=script&setup=true&lang=js"
import style0 from "./IQConfigurationTab.vue?vue&type=style&index=0&id=55770bdf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55770bdf",
  null
  
)

export default component.exports